<template>
  <v-container>
      <h2>
        How much do you think you will borrow?

        <v-tooltip class="test-wrapper" bottom>
          <template v-slot:activator="{ on }">
            <v-icon color="#ffca83" v-on="on">mdi-information</v-icon>
          </template>

          <p>
            Financing is available typically for loans in excess of $350,000. For smaller loans, seller financing is most common. Contact us for additional information.
          </p>
        </v-tooltip>
      </h2>

      <p>
        If you do not know how much you are borrowing, please provide an
        estimate.
      </p>

      <v-form ref="form" @submit.prevent="onContinue">
        <v-text-field
          v-model="dealSize"
          prefix="$"
          label="Type in your estimated loan size, ex: $350,000"
          v-mask="mask"
          solo
          :rules="dealSizeRules" />
      </v-form>

      <button
        class="default-btn blue"
        @click="onContinue"
      >Continue</button>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

const currencyMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: true,
  allowNegative: false,
  integerLimit: 18,
})

export default {
  name: 'QuestionnaireDealSizeStep',
  data: () => ({
    dealSize: '',
    mask: currencyMask,
  }),
  computed: {
    dealSizeRules () {
      return [
        v => !!v || 'Deal size is required.',
        v => parseInt(v.replace(/,/g, '')) >= 200000 || 'Deal size must be at least $200,000',
      ]
    },
  },
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    async onContinue () {
      if (!this.$refs.form.validate()) return

      await this.updateMatchData({
        dealSize: parseInt(this.dealSize.replace(/,/g, '')),
      })

      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  form {
    margin: 20px auto;
    width: 500px;
    max-width: 90%;
  }

  p {
    order: 1;
    margin-top: 0;
    margin-bottom: 10px;

    @include md {
      order: 0;
      margin-top: -50px;
      margin-bottom: 50px;
    }
  }

  .default-btn {
    order: 2;
    @include md { order: 0; }
  }
}

::v-deep {
  .v-input__slot {
    height: 45px;
    width: 100%;
    margin: 0;
    padding: 0 10px;

    background-color: white;
    border: 1px solid #03444b;
    border-radius: 4px;
    box-shadow: none !important;
  }
}
</style>
